import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import LogFilters from './LogFilters';
import LogRow from './LogRow';
import PaginationFooter from '../../components/PaginationFooter';

const HEADERS = [
  { label: 'Hora', align: 'left' },
  { label: 'Nível', align: 'left' },
  { label: 'Canal', align: 'left' },
  { label: 'Mensagem', align: 'left' },
  { label: 'Endpoint', align: 'left' },
  { label: 'Empresa', align: 'left' },
  { label: 'Req', align: 'left' },
];

/**
 * LogsTable - Filtros, tabela e paginação server-side de linhas de log (Admin Geral > Logs)
 * @param {Object} props
 * @param {Array} props.logs
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Object} props.pagination
 * @param {Object} props.filters - props repassadas ao LogFilters
 * @param {string} props.date - dia selecionado
 * @param {Function} props.onPageChange
 * @param {Function} props.onFilterReq
 * @param {Function} props.onFilterCompany
 */
function LogsTable({
  logs = [],
  isLoading = false,
  error = null,
  pagination,
  filters,
  date,
  onPageChange,
  onFilterReq,
  onFilterCompany,
}) {
  const hasActiveFilters = Boolean(
    filters?.channel || filters?.level || filters?.companyInput || filters?.reqInput || filters?.searchInput
  );

  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      <LogFilters {...filters} />

      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    {hasActiveFilters ? 'Nenhum evento com esses filtros' : 'Nenhum evento neste dia'}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              logs.map((log, index) => (
                <LogRow
                  key={`${log.req || 'no-req'}-${log.ts || index}-${index}`}
                  log={log}
                  date={date}
                  onFilterReq={onFilterReq}
                  onFilterCompany={onFilterCompany}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationFooter pagination={pagination} onPageChange={onPageChange} itemLabel="eventos" />
    </Paper>
  );
}

export default LogsTable;
